export const exportModes = {
  BASIC: 'basic',
  EXTENDED: 'extended',
};
